import React, { useState, useEffect } from "react";
import Input from '../components/Input'
// import { Link } from 'react-router-dom'
// import Button from '../components/Button'
import AccountLayout from '../layouts/AccountLayout';
import { useHistory } from "react-router-dom";
import useFormValidation from "../libs/validation/formvalidation";
import { usePost } from "../libs/service/api";
import ValidateAuth from "../libs/validation/createnewpassword-validation";
import Alert from '../components/Alert'
import commonService from "../services/commonService";
// import cookie from "../libs/cookie/client";
// import { useParams } from "react-router-dom";

const Createnewpassword = props => {
    // // const { toast, snackbar } = require('tailwind-toast')
    // const userData = commonService.getUserData();
    const history = useHistory();
    
    const [isSending, setIsSending] = useState("");
    const [apiError, setApiError] = useState("");
    const INITIAL_STATE = {
        emailid: "",
        newpassword: "",
        confirmpassword: ""
    };

    const OnSuccess = () => {
        setIsSending(true)
        
        var hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        hash = hashes[0].split('=');
        
        usePost('/api/auth/resetpassword', { emailid: hash[1], newpassword: values.newpassword }).then(res => {
            
            setIsSending(false);
            if (res.data == "Password changed") {
                // toast().success('', 'Password changed Sucessfully').with({
                //     shape: 'square',
                //     duration: 2000,
                //     speed: 200,
                //     positionX: 'end',
                //     positionY: 'top',
                //     color: 'text-white bg-primary border-primary-dark border rounded-lg',
                //     fontColor: 'white',
                //     fontTone: 0
                // }).show()
                
                history.push('/afcrnewpass')
            } else {
                setApiError(res.data)
            }
        });

    }

    // const forgotPasswordClick = () => {
    //     props.history.push('/Afcrnewpass')
    // }
    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        isSubmitting
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

    // const isDisable = () => {
    //     return isSubmitting || isSending;
    // }

    useEffect(() => {
        setIsSending(false)
        console.log(errors.length)
    }, []);

    return (
        <AccountLayout>
            {apiError &&
                <Alert type="secondary" heading="Password mismatch" content={apiError} isVisible={true} />
            }
            {/* {errors &&  <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.password ? errors.password : ''} isVisible={true} />
            </div>}
            {errors &&<div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.newpassword ? errors.newpassword : ''} isVisible={true} />
            </div>}
            {errors && <div>
                <Alert type="secondary" heading="Create password mismatch" content={errors.confirmpassword ? errors.confirmpassword : ''} isVisible={true} />
            </div>} */}
            <div className="mb-6">Create new password</div>
            <form className="account-form" onSubmit={handleSubmit}>

                <div className="mb-6">

                    <Input label="New Password" type="password" placeholder="*******"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.newpassword}
                        name="newpassword"
                        haserror={errors.newpassword ? 1 : 0}
                        error={errors.newpassword}
                    />
                </div>
                <div className="mb-4 border-b pb-6 border-primary-light">

                    <Input label="Repeat Password" type="password" placeholder="*******"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.confirmpassword}
                        name="confirmpassword"
                        haserror={errors.confirmpassword ? 1 : 0}
                        error={errors.confirmpassword}
                    />
                </div>
                <div className=" mt-10" role="group">
                    {!isSending && (
                        <button type="submit" onClick={props.onClick} className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4">
                            Submit
                        </button>
                    )}
                    {isSending && (

                        <div className="col-3  flex justify-center item-center aheight items-center border-primary text-white font-semibold  text-base  rounded-full  border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4 " >
                            <div className="snippet py-1.5 px-8" data-title=".dot-pulse">
                                <div className="stage">
                                    <div className="dot-pulse"></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </form>
        </AccountLayout>
    )
}
export default Createnewpassword
